import React from 'react';
import { Link } from 'react-router-dom';
import CourseHPC from 'components/Cards/courseHPC';
import './Oxford.css';
import './HarperCollins.css';
import { useTranslation } from 'react-i18next';
import Banner from 'assets/img/banner-hpc.jpg';
import GlobalStore from 'stores/globalStore';

const HarperCollins: React.FC = () => {
  const { bookData } = GlobalStore.useContainer();
  const { t } = useTranslation();

  return (
    <div className='harper-collins'>
      <h2 className="course__title">
        ELSA by Harper Collins
      </h2>
      <p className="course__des">{t('courses.des_harper_collins')}</p>
      <img src={Banner} alt="banner" className="course__banner" />
      <div className="oxfords">
        {bookData.harper.map((hpc, index) => (
          <div
            className="oxford__item"
            key={index}
          >
            <CourseHPC
              product={hpc}
            />
          </div>
        ))}
      </div>
      <div className="nav__mobile">
        <p className="nav__mobile__title">{t('courses.see_more_package')}:</p>
        <Link to="/course/elsa-oxford">
          <button className="nav__mobile__btn">ELSA Oxford Busniess Result</button>
        </Link>
        <Link to="/course/ielts">
          <button className="nav__mobile__btn">IELTS Speaking Test</button>
        </Link>
      </div>
    </div>
  );
};

export default HarperCollins;
